<script setup lang="ts">
const { data: objectList } = useApi<
  components['schemas']['PaginatedEventList']
>('/ticketing/events/', {
  params: {
    featured: true,
    status: ['open'],
    type: 'public',
    has_image_hero: true,
  },
})
</script>

<template>
  <div v-if="objectList?.results.length">
    <Carousel
      :autoplay-interval="5000"
      :show-navigators="false"
      :value="objectList.results"
      circular
    >
      <template #item="{ data }: { data: components['schemas']['Event'] }">
        <NuxtLink v-if="data.image_hero" :to="`/events/${data.slug}`">
          <Image :src="data.image_hero" :alt="data.name" width="100%" />
        </NuxtLink>
      </template>
    </Carousel>
  </div>
</template>
